export const purchaseConstraintFields = [
  {
    name: "minimum_purchase_quantity",
    label: "Minimum purchase",
    hint: "Minimum quantity per purchase, in the main unit. Leave blank for no minimum.",
  },
  {
    name: "purchase_multiple",
    label: "Purchase multiple",
    hint: "Purchase in multiples of this quantity, in the main unit (e.g. 6 bottles). Leave blank for no restriction.",
  },
];

export function serializePurchaseConstraints(form, t = (text) => text) {
  return Object.fromEntries(purchaseConstraintFields.map(({ name, label }) => {
    const input = String(form[name] ?? "").trim();
    if (!input) return [name, null];
    const normalized = input.replace(/^\./, "0.").replace(/^0+(?=\d)/, "").replace(/\.$/, "");
    if (!/^\d{1,10}(\.\d{1,4})?$/.test(normalized) || !/[1-9]/.test(normalized)) {
      throw new Error(`${t(label)}: ${t("Enter a quantity greater than zero, with up to ten integer digits and four decimal places.")}`);
    }
    // Keep decimal strings exact when sending them to the catalog's decimal columns.
    return [name, normalized];
  }));
}
